import Utils from '../../modules/utils'

const saveProperty = (data, callbackFunc) => {
  const url = 'properties'
  Utils.post(url, data, callbackFunc)
}

export {saveProperty}
